import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { handleError, initGroupUser } from '../../lib/lib-util';
import { callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { eKuaibaoSDK } from '@ekuaibao/sdk-bridge/sdk/ekuaibao';
import registerAPI from '../registerAPI';
import initializeTitle from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { fetchHandleError } from '../FetchConfig';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import initLogger from '../../logger/initLogger';
initLogger();
require('../../styles/app.less');
window.__PLANTFORM__ = 'APP';
window.inGroupApp = true;
function startup() {
    app.use({
        id: '@app',
        onready: function () {
            addNcpcCode();
        }
    });
    return callback();
}
fetchHandleError(handleError);
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initGroupUser();
                    initColors();
                    initRoute();
                    initPlatformInfo();
                    app.container.set('IDeviceType', 'DESKTOP');
                    app.container.set('ISMessageEntry', false);
                    app.sdk = app.container.get(eKuaibaoSDK);
                    registerHandler();
                    return [4, startup()];
                case 1:
                    _a.sent();
                    registerAPI();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 6]);
                    return [4, app.sdk.initialize()];
                case 3:
                    _a.sent();
                    setNetworkAdapter();
                    return [3, 6];
                case 4:
                    e_1 = _a.sent();
                    return [4, newHomeConfig()];
                case 5:
                    _a.sent();
                    setNetworkAdapter();
                    return [2];
                case 6: return [4, newHomeConfig()];
                case 7:
                    _a.sent();
                    initializeTitle();
                    return [2];
            }
        });
    });
}
